import {
  createApiClient,
  createDiagnostics,
  getBrowserContext,
  isDebugRequested,
  typed,
  type ApiProblem,
} from '@ticarishift/api-client/runtime';
import type { paths } from '@ticarishift/api-client/platform';

/**
 * Oturum uçlarının kökü (ADR-002 §2.2): refresh çerezi yalnız bu yolda ve yalnız backoffice alan adındadır; panelin
 * `/api/v1/auth` çerezi buraya gitmez.
 */
export const PLATFORM_AUTH_PATH = '/api/platform/auth';

type SessionHandlers = {
  onSessionRejected?: (problem: ApiProblem) => void;
};

const handlers: SessionHandlers = {};

/**
 * Oturum sağlayıcısı çalışma zamanının kancasına buradan bağlanır (istemci modül tekilidir; React ağacı sonradan
 * kurulur). Dönen fonksiyon bağlantıyı kaldırır.
 */
export function setSessionHandlers(next: SessionHandlers): () => void {
  Object.assign(handlers, next);
  return () => {
    for (const key of Object.keys(next) as (keyof SessionHandlers)[]) {
      if (handlers[key] === next[key]) {
        delete handlers[key];
      }
    }
  };
}

/** Tanı kaydı yalnız `?debug=1` ile açılan sekmede tutulur (S09). */
export const diagnostics = createDiagnostics(typeof window !== 'undefined' && isDebugRequested(window.location.search), {
  context: getBrowserContext(),
});

/**
 * Backoffice'in API istemcisi (ADR-002): yalnız platform sözleşmesi (`/api/platform/*`). Erişim jetonu bellekte, refresh
 * HttpOnly çerezde; 401'de tek uçuşlu yenileme, yenileme reddedilirse (8 saatlik mutlak ömür doldu, üyelik kapandı)
 * oturum kapanır ve oturum açma ekranı açılır. Adım yükseltme (step-up) platformda yoktur: her oturum zaten TOTP'lidir.
 */
export const apiClient = createApiClient({
  authBasePath: PLATFORM_AUTH_PATH,
  diagnostics,
  onSessionRejected: (problem) => handlers.onSessionRejected?.(problem),
});

/** Platform sözleşmesindeki yollarla tipli çağrılar. */
export const api = typed<paths>(apiClient);
